module.exports = __webpack_public_path__ + "img/wlwzk.0786dc92.png";